import { render, staticRenderFns } from "./ArchiveModal.vue?vue&type=template&id=048ca2f6"
import script from "./ArchiveModal.vue?vue&type=script&lang=ts"
export * from "./ArchiveModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports